module.exports = __webpack_public_path__ + "static/media/tim.7b3fe0d2.svg";